import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=dc50b02e&scoped=true&"
import script from "./practice.vue?vue&type=script&lang=js&"
export * from "./practice.vue?vue&type=script&lang=js&"
import style0 from "./practice.vue?vue&type=style&index=0&id=dc50b02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc50b02e",
  null
  
)

export default component.exports